export const TRACKER_EVENT_VP_EDU_KARIER_BANNER_CLICK = 'vp_edukarier_banner_click';
export const TRACKER_EVENT_VP_EDU_KARIER_VISIT_PAGE_VIEW = 'vp_edukarier_visit_page';
export const TRACKER_EVENT_VP_EDU_KARIER_SECTION_CLICK = 'vp_edukarier_section_click';
export const TRACKER_EVENT_VP_EDU_KARIER_LEMBAGA_REGISTER_CLICK = 'vp_edukarier_lembaga_register_click';
export const TRACKER_EVENT_VP_EDU_KARIER_PDP_CLICK = 'vp_edukarier_pdp_click';
export const TRACKER_EVENT_VP_EDU_KARIER_SEARCH = 'vp_edukarier_search';
